/* ==========================================================
   EXQUISITE TILE — MY PROJECTS (sistema único)
   ----------------------------------------------------------
   UN solo lugar para guardar proyectos. Lo usan:
     - El corazón de las tarjetas      [data-ex-save]
     - "Save to Project" del producto  [data-ex-save]
     - La página My Projects           [data-ex-projects-page]
     - El contador del header          [data-ex-projects-count]

   Cómo se marca un botón:
     <button data-ex-save data-ex-product='{"id":1,"title":"...","url":"...","image":"...","handle":"..."}'>
     o varios productos a la vez:  data-ex-products='[{...},{...}]'
     (data-ex-with-calc ya no se usa: la cantidad se escribe en el correo.)

   REGLAS — pensadas para no tener que volver a tocarlas:
     · El corazón solo dice DÓNDE está guardado un azulejo. Nunca guarda cantidades.
     · ♡ vacío → lista de proyectos (los del cliente primero, el último usado arriba).
     · ♥ y el cliente tiene UN solo proyecto → interruptor de un toque (con "Undo").
     · ♥ y el cliente tiene 2 o más proyectos → lista con ✓: un toque en un espacio
       agrega o quita, y la lista se cierra. La regla depende de cuántos proyectos tiene
       el CLIENTE (no del azulejo): así todos los corazones de una pantalla se portan igual.
     · La cantidad la escribe el cliente en el correo de cotización ("Square feet needed:
       ____"): nada oculto ni viejo viaja sin que él lo vea.
     · Compartir: cada proyecto tiene un ícono de compartir. En celular abre el menú del
       teléfono (WhatsApp, iMessage, correo…); en computador copia el enlace. Quien lo recibe
       ve el proyecto con sus fotos ANTES de guardarlo. Si ya tiene un proyecto con ese
       nombre, el nuevo se guarda aparte ("… (shared)"): nunca se mezclan los azulejos de
       dos personas. El enlace lleva solo nombre y códigos de producto (nada personal).
     · Medición: las acciones importantes avisan con el evento "ex:track" (y a
       Shopify.analytics si existe), sin datos personales. Se conecta más adelante sin
       volver a editar este archivo.

   Datos: localStorage "ex_projects_v2" (una sola llave). Si algún día el dato se daña,
   se guarda una copia en "ex_projects_v2_bad" antes de empezar de cero.
   Migra automáticamente los datos viejos (exquisite_project_*)
   y BORRA para siempre "exquisite_sample_box".
   ========================================================== */
(function () {
  'use strict';

  if (window.ExProjects) return;

  var cfg = window.ExConfig || {};
  var KEY = 'ex_projects_v2';
  var DEFAULT_SPACES = (cfg.spaces && cfg.spaces.length) ? cfg.spaces : [
    'Master Bathroom', 'Guest Bathroom', 'Kids Bathroom', 'Kitchen Backsplash',
    'Kitchen Floor', 'Fireplace', 'General Flooring', 'Outdoor'
  ];
  var PROJECTS_URL = cfg.projectsUrl || '/pages/my-projects';
  var SAMPLES_LABEL = 'Order Samples for This Project';

  /* ==========================================================
     1. ALMACENAMIENTO SEGURO
     Si el navegador bloquea localStorage (modo privado), usa memoria.
     ========================================================== */
  var memory = {};
  var store = {
    get: function (k) {
      try { return window.localStorage.getItem(k); } catch (e) { return memory[k] || null; }
    },
    set: function (k, v) {
      try { window.localStorage.setItem(k, v); } catch (e) { memory[k] = v; }
    },
    remove: function (k) {
      try { window.localStorage.removeItem(k); } catch (e) { delete memory[k]; }
    },
    keys: function () {
      var out = [];
      try {
        for (var i = 0; i < window.localStorage.length; i++) out.push(window.localStorage.key(i));
      } catch (e) { out = Object.keys(memory); }
      return out;
    }
  };

  function now() { return Date.now(); }

  function slug(name) {
    return String(name || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'project';
  }

  function cleanName(name) {
    return String(name || '').replace(/\s+/g, ' ').trim().slice(0, 60);
  }

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; } // %-raro no debe romper nada
  }

  // Tipos de producto que entrega el tema (snippets/ex-product-mode.liquid)
  function isMode(m) { return m === 'quote' || m === 'buy' || m === 'sample'; }

  // Normaliza un producto para que siempre tenga la misma forma
  function normItem(p) {
    if (!p) return null;
    var url = String(p.url || '').split('?')[0];
    var item = {
      id: p.id != null && p.id !== '' ? String(p.id) : '',
      handle: p.handle || handleFromUrl(url),
      title: String(p.title || '').slice(0, 200),
      url: url,
      image: p.image || '',
      sku: String(p.sku || '').slice(0, 60),
      addedAt: p.addedAt || now()
    };
    // EXQUISITE: tipo del producto. quote = se cotiza · buy = se compra directo ·
    // sample = es una muestra. Si no viene (proyectos guardados antes), queda
    // vacío y se completa solo.
    if (isMode(p.mode)) item.mode = p.mode;
    if (!item.id && !item.handle && !item.url) return null;
    return item;
  }

  // Llave única de un producto (id > handle > url)
  function itemKey(p) {
    if (!p) return '';
    if (p.id) return 'id:' + p.id;
    if (p.handle) return 'h:' + p.handle;
    return 'u:' + (p.url || '');
  }

  function sameItem(a, b) {
    if (!a || !b) return false;
    if (a.id && b.id) return a.id === b.id;
    if (a.handle && b.handle) return a.handle === b.handle;
    return !!a.url && a.url === b.url;
  }

  /* ==========================================================
     2. ESTADO
     ========================================================== */
  var state = { v: 2, projects: [] };

  function load() {
    var raw = store.get(KEY);
    var parsed = null;
    try { parsed = raw ? JSON.parse(raw) : null; } catch (e) { parsed = null; }
    if (parsed && Array.isArray(parsed.projects)) {
      var dirty = false; // ¿venía algo dañado? Si sí, se guarda una copia antes de descartarlo
      var good = parsed.projects.filter(function (p) { return p && p.name && Array.isArray(p.items); });
      if (good.length !== parsed.projects.length) dirty = true;
      good.forEach(function (p) {
        if (!p.id || typeof p.id !== 'string') p.id = slug(p.name); // sin id válido: se calcula
        var items = p.items.filter(function (x) { return x && typeof x === 'object'; });
        if (items.length !== p.items.length) dirty = true;
        p.items = items;
      });
      if (dirty) store.set(KEY + '_bad', raw);
      state = { v: 2, projects: good };
    } else {
      // Dato ilegible: no se pierde. Queda una copia aparte y se empieza limpio.
      if (raw) store.set(KEY + '_bad', raw);
      state = { v: 2, projects: [] };
    }
  }

  function save() {
    store.set(KEY, JSON.stringify(state));
    emit();
  }

  function findProject(name) {
    var s = slug(name);
    for (var i = 0; i < state.projects.length; i++) {
      if (state.projects[i].id === s) return state.projects[i];
    }
    return null;
  }

  function ensureProject(name) {
    name = cleanName(name);
    if (!name) return null;
    var p = findProject(name);
    if (!p) {
      p = { id: slug(name), name: name, createdAt: now(), updatedAt: now(), items: [] };
      state.projects.push(p);
    }
    return p;
  }

  /* ---------- Migración desde el sistema viejo ---------- */
  function migrate() {
    var changed = false;
    store.keys().forEach(function (k) {
      if (!k) return;
      if (k.indexOf('exquisite_project_') === 0) {
        var name = k.replace('exquisite_project_', '');
        var items = [];
        try { items = JSON.parse(store.get(k) || '[]'); } catch (e) { items = []; }
        if (Array.isArray(items) && items.length) {
          var proj = ensureProject(name);
          items.forEach(function (raw) {
            var it = normItem(raw);
            if (it && proj && !proj.items.some(function (x) { return sameItem(x, it); })) {
              proj.items.push(it);
            }
          });
        }
        store.remove(k);
        changed = true;
      } else if (k.indexOf('exquisite_unhearted_') === 0 || k === 'exquisite_sample_box') {
        // "My Sample Box" y marcas viejas: eliminados para siempre
        store.remove(k);
      }
    });
    if (changed) store.set(KEY, JSON.stringify(state));
  }

  /* ==========================================================
     3. OPERACIONES
     ========================================================== */
  function addItems(projectName, products) {
    var proj = ensureProject(projectName);
    if (!proj) return null;
    products.forEach(function (raw) {
      var it = normItem(raw);
      if (!it) return;
      var existing = proj.items.filter(function (x) { return sameItem(x, it); })[0];
      if (existing) {
        // Ya estaba: solo se completan datos que le faltaban
        if (it.sku && !existing.sku) existing.sku = it.sku;
        if (it.mode && !existing.mode) existing.mode = it.mode;
      } else {
        proj.items.push(it);
      }
    });
    if (!proj.items.length) {
      // Ningún producto válido: no se deja un proyecto vacío flotando
      state.projects = state.projects.filter(function (x) { return x !== proj; });
      return null;
    }
    proj.updatedAt = now();
    save();
    return proj;
  }

  function removeItems(projectId, products) {
    var proj = state.projects.filter(function (p) { return p.id === projectId; })[0];
    if (!proj) return;
    proj.items = proj.items.filter(function (x) {
      return !products.some(function (p) { return sameItem(x, normItem(p) || p); });
    });
    // Quitar NO cambia updatedAt: la lista de proyectos se ordena por "último guardado",
    // y no debe saltar de lugar mientras el cliente va quitando azulejos.
    save();
  }

  function removeItemByKey(projectId, key) {
    var proj = state.projects.filter(function (p) { return p.id === projectId; })[0];
    if (!proj) return;
    proj.items = proj.items.filter(function (x) { return itemKey(x) !== key; });
    save(); // (sin tocar updatedAt: ver removeItems)
  }

  function deleteProject(projectId) {
    state.projects = state.projects.filter(function (p) { return p.id !== projectId; });
    save();
  }

  // "Undo": devuelve azulejos a un proyecto (si ya no existe, lo crea de nuevo igual que
  // estaba) sin duplicar nada. NO guarda: quien llama hace save() al final.
  var UNDO_MS_PROJECT = 8000; // borrar un proyecto entero: un poco más de tiempo para deshacer
  function restoreInto(name, items, meta) {
    var existed = !!findProject(name);
    var proj = ensureProject(name);
    if (!proj) return;
    items.forEach(function (it) {
      if (proj.items.some(function (x) { return sameItem(x, it); })) return;
      if (existed && items.length === 1 && meta && typeof meta.index === 'number') {
        // Un solo azulejo que se quitó: vuelve exactamente al lugar donde estaba
        proj.items.splice(Math.max(0, Math.min(meta.index, proj.items.length)), 0, it);
      } else {
        proj.items.push(it);
      }
    });
    if (!existed && meta) {
      // el proyecto vuelve a su lugar de antes (misma antigüedad)
      proj.createdAt = meta.createdAt || proj.createdAt;
      proj.updatedAt = meta.updatedAt || proj.updatedAt;
    } else if (!meta || typeof meta.index !== 'number') {
      // Se mezcló con un proyecto nuevo del mismo nombre: sube al inicio, como cualquier guardado.
      // (Un azulejo que vuelve a su lugar no reordena la lista.)
      proj.updatedAt = now();
    }
  }

  function projectHasAll(proj, products) {
    if (!proj || !products.length) return false;
    return products.every(function (p) {
      var it = normItem(p);
      return proj.items.some(function (x) { return sameItem(x, it); });
    });
  }

  function isSaved(product) {
    var it = normItem(product);
    if (!it) return false;
    return state.projects.some(function (proj) {
      return proj.items.some(function (x) { return sameItem(x, it); });
    });
  }

  function totalItems() {
    var seen = {};
    state.projects.forEach(function (p) { p.items.forEach(function (x) { seen[itemKey(x)] = 1; }); });
    return Object.keys(seen).length;
  }

  // Cuántos proyectos tiene el cliente (los vacíos no cuentan: no se ven en ninguna parte)
  function projectCount() {
    return state.projects.filter(function (p) { return p.items.length; }).length;
  }

  /* ==========================================================
     MEDICIÓN — avisa lo importante sin datos personales (ni nombres de proyecto).
     Se puede conectar más adelante (Google Analytics, Meta, Klaviyo…) escuchando el
     evento "ex:track", o con un pixel de Shopify, sin volver a editar este archivo.
     ========================================================== */
  function track(name, data) {
    try {
      data = data || {};
      document.dispatchEvent(new CustomEvent('ex:track', { detail: { name: name, data: data } }));
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') {
        var r = a.publish(name, data);
        if (r && typeof r.catch === 'function') r.catch(function () { /* nada */ });
      }
    } catch (e) { /* medir nunca debe romper la tienda */ }
  }

  /* ==========================================================
     4. SINCRONIZAR LA INTERFAZ (corazones + contador)
     ========================================================== */
  function readProducts(el) {
    var list = [];
    try {
      if (el.hasAttribute('data-ex-products')) list = JSON.parse(el.getAttribute('data-ex-products')) || [];
      else if (el.hasAttribute('data-ex-product')) list = [JSON.parse(el.getAttribute('data-ex-product'))];
    } catch (e) { list = []; }
    return list.filter(Boolean);
  }

  function syncHearts() {
    var multi = projectCount() > 1; // con varios proyectos, un corazón lleno abre la lista
    document.querySelectorAll('[data-ex-save]').forEach(function (btn) {
      if (btn.hasAttribute('data-ex-products')) return; // botones de "varios" no se marcan
      var p = readProducts(btn)[0];
      var saved = isSaved(p);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      // Solo cambia el tooltip: el aria-label se queda igual y aria-pressed
      // ya le dice al lector de pantalla si está marcado (patrón correcto).
      //  · corazón de tarjeta, cliente con 1 proyecto → un toque lo quita
      //  · corazón de tarjeta, cliente con 2+          → un toque abre la lista
      //  · botón con texto de la ficha                 → siempre abre la lista
      var label = btn.querySelector('[data-ex-save-label]');
      if (!btn.hasAttribute('data-ex-title0')) btn.setAttribute('data-ex-title0', btn.getAttribute('title') || '');
      var nextTitle = btn.getAttribute('data-ex-title0');
      if (saved) nextTitle = (label || multi) ? 'Change projects' : 'Remove from My Projects';
      if (nextTitle) {
        if (btn.getAttribute('title') !== nextTitle) btn.setAttribute('title', nextTitle);
      } else if (btn.hasAttribute('title')) {
        btn.removeAttribute('title'); // sin tooltip original: no se queda el de "guardado"
      }
      if (label) {
        var txt = saved ? (btn.getAttribute('data-label-saved') || 'Saved to Project') : (btn.getAttribute('data-label') || 'Save to Project');
        // Solo escribe si cambió (evita bucles con el MutationObserver)
        if (label.textContent !== txt) label.textContent = txt;
      }
    });

    var total = totalItems();
    var totalTxt = total > 99 ? '99+' : String(total);
    document.querySelectorAll('[data-ex-projects-count]').forEach(function (el) {
      if (el.textContent !== totalTxt) el.textContent = totalTxt;
      if (el.hidden !== (total === 0)) el.hidden = total === 0;
    });
  }

  function emit() {
    syncHearts();
    renderPage();
    // Si la lista de proyectos está abierta se pone al día (ej. otra pestaña guardó algo)
    if (modal && !modal.hidden) renderModalList();
    document.dispatchEvent(new CustomEvent('ex:projects-changed', { detail: state }));
  }

  /* ==========================================================
     5. MODAL "ADD TO PROJECT"
     ========================================================== */
  var modal = null;
  var pending = [];
  var lastFocus = null;

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'ex-modal';
    modal.id = 'ExProjectModal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="ex-modal__overlay" data-ex-modal-close></div>' +
      '<div class="ex-modal__box" role="dialog" aria-modal="true" aria-labelledby="ExProjectModalTitle">' +
        '<div class="ex-modal__head">' +
          '<h3 class="ex-modal__title" id="ExProjectModalTitle">Add to Project</h3>' +
          '<button type="button" class="ex-modal__close" data-ex-modal-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<p class="ex-modal__subtitle">Select a space:</p>' +
        '<div class="ex-modal__list" data-ex-modal-list role="group" aria-label="Spaces"></div>' +
        '<form class="ex-modal__new" data-ex-modal-form>' +
          '<input type="text" class="ex-modal__input" maxlength="60" placeholder="New project name…" aria-label="New project name" data-ex-modal-input>' +
          '<button type="submit" class="ex-btn ex-btn--dark">Save</button>' +
        '</form>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ex-modal-close]')) { closeModal(); return; }
      var row = e.target.closest('[data-ex-space]');
      if (row) toggleSpace(row.getAttribute('data-ex-space'));
    });

    // El teclado (Tab) se queda dentro de la ventana mientras está abierta
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || modal.hidden) return;
      var nodes = Array.prototype.filter.call(modal.querySelectorAll('button, input, a[href]'), function (el) {
        return !el.disabled && el.getClientRects().length > 0;
      });
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || !modal.contains(active))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (active === last || !modal.contains(active))) { e.preventDefault(); first.focus(); }
    });

    modal.querySelector('[data-ex-modal-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = modal.querySelector('[data-ex-modal-input]');
      var name = cleanName(input.value);
      if (!name) { input.focus(); return; }
      input.value = '';
      saveTo(name);
    });

    return modal;
  }

  // Título y texto de la ventana según el caso: azulejo nuevo, o ya guardado en algún proyecto
  function paintModalHead() {
    var inSome = pending.some(function (p) { return isSaved(p); });
    modal.querySelector('.ex-modal__title').textContent = inSome ? 'Choose Spaces' : 'Add to Project';
    modal.querySelector('.ex-modal__subtitle').textContent = inSome ? 'Tap a space to add or remove it.' : 'Select a space:';
  }

  function renderModalList() {
    paintModalHead();
    var list = modal.querySelector('[data-ex-modal-list]');
    // Si el teclado estaba en una fila, el foco vuelve a esa misma fila al redibujar
    var focusedSpace = (document.activeElement && list.contains(document.activeElement))
      ? document.activeElement.getAttribute('data-ex-space') : null;
    // Primero los proyectos del cliente (el último usado arriba) y después los espacios
    // sugeridos que todavía no usa (sin repetir): lo más probable queda a un toque.
    var names = state.projects
      .filter(function (p) { return p.items.length; })
      .sort(function (a, b) { return (b.updatedAt || 0) - (a.updatedAt || 0); })
      .map(function (p) { return p.name; });
    DEFAULT_SPACES.forEach(function (n) {
      var s = slug(n);
      if (!names.some(function (x) { return slug(x) === s; })) names.push(n);
    });
    list.innerHTML = names.map(function (name) {
      var proj = findProject(name);
      var inIt = projectHasAll(proj, pending);
      var count = proj ? proj.items.length : 0;
      // aria-pressed: el lector de pantalla dice si el espacio está marcado (el ✓ es solo visual)
      return '<button type="button" class="ex-modal__row' + (inIt ? ' is-in' : '') + '" data-ex-space="' + esc(name) + '" aria-pressed="' + (inIt ? 'true' : 'false') + '">' +
        '<span>' + esc(proj ? proj.name : name) + (count ? ' <span class="ex-modal__row-count">(' + count + ')</span>' : '') + '</span>' +
        (inIt ? '<span class="ex-modal__row-check" aria-hidden="true">✓</span>' : '') +
      '</button>';
    }).join('');
    if (focusedSpace !== null) {
      var rows = list.querySelectorAll('[data-ex-space]');
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].getAttribute('data-ex-space') === focusedSpace) { rows[i].focus({ preventScroll: true }); break; }
      }
    }
  }

  function openModal(products) {
    pending = products || [];
    if (!pending.length) return;
    buildModal();
    renderModalList();
    lastFocus = document.activeElement;
    // Si venía del aviso (que ya se esconde), no se le devuelve el foco
    if (lastFocus && toastEl && toastEl.contains(lastFocus)) lastFocus = null;
    modal.hidden = false;
    document.body.classList.add('ex-lock-scroll');
    var first = modal.querySelector('.ex-modal__row');
    if (first) first.focus({ preventScroll: true });
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('ex-lock-scroll');
    pending = [];
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  // La lista SIEMPRE se porta igual: un toque en un espacio lo agrega (si el azulejo no
  // estaba ahí) o lo quita (si ya estaba, con "Undo"), la ventana se cierra y un aviso
  // confirma lo que pasó.
  function toggleSpace(name) {
    var proj = findProject(name);
    if (proj && projectHasAll(proj, pending)) {
      var items = pending.slice();
      closeModal();
      removeFromProject(proj, items);
    } else {
      saveTo(name);
    }
  }

  // Quita azulejos de UN proyecto. Un proyecto que queda vacío se limpia solo.
  function removeFromProject(proj, products) {
    var gone = proj.items.filter(function (x) {
      return products.some(function (p) { return sameItem(x, normItem(p)); });
    });
    if (!gone.length) return;
    var name = proj.name;
    var snap = JSON.parse(JSON.stringify(gone));
    var meta = { createdAt: proj.createdAt, updatedAt: proj.updatedAt, index: proj.items.indexOf(gone[0]) };
    removeItems(proj.id, products);
    if (!proj.items.length) deleteProject(proj.id);
    track('ex_project_removed', { handles: snap.map(handleOf), projects: projectCount() });
    toast('Removed from ' + name, '', 'Undo', function () {
      restoreInto(name, snap, meta);
      save();
    });
  }

  function saveTo(name) {
    var items = pending.slice(); // closeModal() vacía "pending"
    var proj = addItems(name, items);
    closeModal();
    if (!proj) return;
    popHearts(items);
    track('ex_project_saved', { handles: items.map(handleOf), projects: projectCount() });
    // "Change" abre la lista para ponerlo también en otro espacio (o quitarlo)
    toast('Saved to ' + proj.name, PROJECTS_URL, 'View My Projects', null, 6000, {
      text: 'Change',
      fn: function () {
        // El foco pasa primero al corazón del producto: al cerrar la lista, el teclado
        // vuelve ahí y no al aviso (que ya se escondió).
        var heart = heartOf(items[0]);
        if (heart) heart.focus({ preventScroll: true });
        openModal(items);
      }
    });
  }

  // Primer corazón/botón visible de un producto en la página (o null)
  function heartOf(product) {
    var it = normItem(product);
    if (!it) return null;
    var btns = document.querySelectorAll('[data-ex-save]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].hasAttribute('data-ex-products')) continue;
      var b = normItem(readProducts(btns[i])[0]);
      if (b && sameItem(b, it) && btns[i].getClientRects().length > 0) return btns[i];
    }
    return null;
  }

  /* ---------- Toast (aviso pequeño abajo) ---------- */
  var toastEl = null;
  var toastTimer = null;
  var toastAction = null;
  var toastExtra = null;
  // toast(mensaje, enlace, textoEnlace)  → aviso con enlace
  // toast(mensaje, '', textoBoton, función[, milisegundos]) → aviso con botón de acción (ej. "Undo")
  // toast(mensaje, enlace, textoEnlace, null, ms, { text, fn }) → además una acción extra
  //   que va antes del enlace (ej. "Change")
  function toast(msg, href, linkText, action, ms, extra) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ex-toast';
      // El aviso está centrado con left:50%, y así el navegador lo deja medir solo la mitad
      // de la pantalla (en el celular se partía en 3 renglones). max-content lo deja del
      // tamaño de su texto; border-box + max-width hacen que, con todo y su relleno, nunca
      // se salga de la pantalla (deja 16 px a cada lado).
      toastEl.style.width = 'max-content';
      toastEl.style.boxSizing = 'border-box';
      toastEl.style.maxWidth = 'calc(100% - 32px)';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.addEventListener('click', function (e) {
        var isExtra = !!e.target.closest('[data-ex-toast-extra]');
        if (!isExtra && !e.target.closest('[data-ex-toast-action]')) return;
        e.preventDefault();
        var fn = isExtra ? toastExtra : toastAction;
        toastAction = null;
        toastExtra = null;
        toastEl.classList.remove('is-visible');
        if (typeof fn === 'function') fn();
      });
      document.body.appendChild(toastEl);
    }
    toastAction = typeof action === 'function' ? action : null;
    toastExtra = (extra && typeof extra.fn === 'function') ? extra.fn : null;
    toastEl.innerHTML = '<span>' + esc(msg) + '</span>' +
      (toastExtra ? '<a href="#" data-ex-toast-extra>' + esc(extra.text) + '</a>' : '') +
      (toastAction ? '<a href="#" data-ex-toast-action>' + esc(linkText) + '</a>'
        : (href ? '<a href="' + esc(href) + '">' + esc(linkText) + '</a>' : ''));
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    // Con "Undo" / "Change" se deja más tiempo para alcanzar a tocarlo
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
      toastAction = null;
      toastExtra = null;
    }, ms || ((toastAction || toastExtra) ? 6000 : 3500));
  }

  /* ==========================================================
     6. PÁGINA MY PROJECTS
     ========================================================== */
  function pageRoot() { return document.querySelector('[data-ex-projects-page]'); }

  // Ícono ✕ de línea fina (el color lo pone el CSS con currentColor)
  var X_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function telHref(phone) { return 'tel:' + String(phone || '').replace(/[^0-9+]/g, ''); }

  // Cuerpo del mensaje de cotización (compartido por el correo y por el texto de "Copy request")
  // Producto que se compra directo en la tienda (tiene precio en línea).
  // Sin tipo (proyecto viejo) = se trata como cotización.
  function isBuyItem(it) { return it && it.mode === 'buy'; }

  // Nombre de la tienda para el saludo. Si el nombre guardado en Shopify no
  // tiene letras ni números (ej. "."), se usa el nombre real: así el correo
  // nunca empieza con "Hello .,".
  function shopLabel() {
    var n = String(cfg.shopName || '').trim();
    return /[A-Za-z0-9]/.test(n) ? n : 'Exquisite Tile';
  }

  // EXQUISITE: UNA sola lista con TODO el proyecto y UNA sola solicitud.
  // La cantidad la escribe el cliente (así nada oculto ni viejo viaja en el correo): cada
  // línea lleva su espacio "Square feet needed: ____", en pies cuadrados, que es lo que el
  // cliente sí conoce. Los productos con precio en línea llevan "Quantity needed: ____" y
  // una marca discreta. La tienda responde con una cotización personalizada.
  // level 0 = completo (con enlaces) · 1 = compacto (sin enlaces) · 2 = solo el enlace
  // compartido. Los niveles 1 y 2 existen porque muchos programas de correo (Outlook)
  // cortan o rechazan los mailto: de más de ~2000 caracteres. En los tres el cliente
  // tiene dónde escribir la cantidad.
  var BLANK = '____';
  function quoteBody(proj, level) {
    level = level || 0;
    var lines = proj.items.map(function (it, i) {
      var buy = isBuyItem(it);
      var tag = buy ? ' (also available online)' : '';
      var ask = (buy ? 'Quantity needed: ' : 'Square feet needed: ') + BLANK;
      if (level === 1) {
        // Código del producto (SKU) primero: es lo más importante para cotizar
        return (i + 1) + '. ' + it.title + tag + (it.sku ? ' - SKU: ' + it.sku : '') + ' - ' + ask;
      }
      return (i + 1) + '. ' + it.title + tag +
        (it.sku ? '\n   SKU: ' + it.sku : '') +
        '\n   ' + ask +
        '\n   ' + window.location.origin + it.url;
    });
    var n = proj.items.length;
    var list = level === 2
      ? n + ' item' + (n === 1 ? '' : 's') + ' - the full list is in the link below.\nSquare feet needed for each tile: ' + BLANK
      : lines.join(level === 0 ? '\n\n' : '\n');
    return 'Hello ' + shopLabel() + ',\n\nI would like a quote for my project "' + proj.name + '":\n\n' +
      list + '\n\nNot sure how many square feet? Tell us the room size and we will help.' +
      '\n\nName:\nPhone:\nDelivery address:\nCity, State, ZIP code:' +
      '\n\nShared list: ' + shareUrl(proj) + '\n';
  }

  var MAILTO_MAX = 1900;
  function mailHref(proj) {
    var base = 'mailto:' + (cfg.email || '') + '?subject=' + encodeURIComponent('Project quote request: ' + proj.name) + '&body=';
    var href = '';
    for (var level = 0; level <= 2; level++) {
      href = base + encodeURIComponent(quoteBody(proj, level));
      if (href.length <= MAILTO_MAX) break;
    }
    return href;
  }

  // EXQUISITE: texto plano de la cotización. El botón de correo (mailto:)
  // depende de que el celular/compu tenga una app de correo configurada —
  // muchos no la tienen. Por eso, al tocar "Email Quote Request" sale un
  // aviso con "Copy request": el cliente pega la misma cotización en un
  // mensaje de texto, WhatsApp o Gmail desde el navegador. Nunca se queda
  // sin poder pedirla (y sin un botón más en la página).
  function quoteText(proj) {
    return 'Subject: Project quote request: ' + proj.name + '\n\n' + quoteBody(proj);
  }

  /* ---------- Compartir (abrir el proyecto en otro dispositivo) ---------- */
  function b64encode(str) {
    var bytes = new TextEncoder().encode(str);
    var bin = '';
    bytes.forEach(function (b) { bin += String.fromCharCode(b); });
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64decode(str) {
    str = String(str).replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    var bin = atob(str);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new TextDecoder().decode(bytes);
  }

  function shareUrl(proj) {
    // Solo viajan el nombre y los handles → link corto (los enlaces viejos con
    // cantidades todavía se abren: lo que sobra se ignora)
    var payload = {
      n: proj.name,
      i: proj.items.map(function (it) { return [it.handle || handleFromUrl(it.url)]; })
        .filter(function (r) { return r[0]; })
    };
    return window.location.origin + PROJECTS_URL + '?project=' + b64encode(JSON.stringify(payload));
  }

  // Copia al portapapeles. La promesa dice si SÍ se pudo copiar (true / false): así nunca se le
  // dice "copiado" al cliente cuando no lo está. Si el navegador rechaza el método moderno
  // (permisos, página no segura) usa el método antiguo.
  function copyText(text) {
    function legacy() {
      return new Promise(function (resolve) {
        var done = false, ta = null;
        try {
          ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { ta.setSelectionRange(0, text.length); } catch (e) { /* nada */ } // el iPhone lo necesita
          done = !!document.execCommand('copy');
        } catch (e) { done = false; } // pase lo que pase, la promesa se resuelve (true / false)
        if (ta && ta.parentNode) ta.parentNode.removeChild(ta);
        resolve(done);
      });
    }
    if (navigator.clipboard && window.isSecureContext) {
      try { return navigator.clipboard.writeText(text).then(function () { return true; }, legacy); } catch (e) { return legacy(); }
    }
    return legacy();
  }

  /* ---------- Compartir un proyecto ---------- */
  // Ícono de compartir de línea fina (flecha que sale de una caja; el color lo pone el CSS)
  var SHARE_ICON = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M12 15V4M8 8l4-4 4 4M5 13v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5"/></svg>';

  // El menú de compartir del teléfono (WhatsApp, iMessage, correo…) solo se usa en pantallas
  // táctiles: en computador "copiar el enlace" es más rápido y siempre se comporta igual.
  function wantsNativeShare() {
    try {
      return typeof navigator.share === 'function' && !!window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    } catch (e) { return false; }
  }

  function shareProject(proj) {
    var url = shareUrl(proj);
    var n = proj.items.length;
    function copyLink() {
      copyText(url).then(function (copied) {
        if (!copied) { toast('Could not copy the link. Please try again.'); return; }
        track('ex_project_shared', { method: 'copy', items: n });
        toast('Link copied. Paste it in a message or email.');
      });
    }
    if (!wantsNativeShare()) { copyLink(); return; }
    try {
      navigator.share({
        title: proj.name + ' - ' + shopLabel(),
        text: 'Take a look at my tile project "' + proj.name + '" (' + n + ' item' + (n === 1 ? '' : 's') + ') at ' + shopLabel() + '.',
        url: url
      }).then(function () {
        track('ex_project_shared', { method: 'native', items: n });
      }, function (err) {
        if (err && err.name === 'AbortError') return; // cerró el menú sin compartir: no pasa nada
        copyLink();
      });
    } catch (e) { copyLink(); }
  }

  /* ---------- Recibir un proyecto compartido ---------- */
  var importData = null;   // proyecto que llegó por enlace: { n: nombre, i: [[handle], …] }
  var importBad = false;   // el enlace traía ?project= pero no se pudo leer
  var importItems = null;  // productos de ese enlace, ya leídos de la tienda
  var importMissing = 0;   // cuántos del enlace ya no existen en la tienda
  var importTotal = 0;     // cuántos azulejos traía el enlace (antes de recortar)
  var importState = '';    // '' | 'loading' | 'ready' | 'empty'
  var IMPORT_MAX = 100;    // máximo de azulejos que se leen de un enlace

  function readImport() {
    var params = new URLSearchParams(window.location.search);
    var code = params.get('project');
    if (!code) return;
    try {
      var data = JSON.parse(b64decode(code));
      if (data && Array.isArray(data.i)) {
        importTotal = data.i.length;
        importData = { n: cleanName(typeof data.n === 'string' ? data.n : '') || 'Shared project', i: data.i.slice(0, IMPORT_MAX) };
      }
    } catch (e) { importData = null; }
    if (!importData) importBad = true;
  }

  // Lee de la tienda un producto del enlace. Del enlace solo se usa el código (handle):
  // el nombre, la foto y el SKU salen siempre del catálogo real.
  function fetchSharedProduct(root, row) {
    var handle = Array.isArray(row) ? row[0] : '';
    if (!handle || typeof handle !== 'string') return Promise.resolve(null); // fila dañada: se salta
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.handle) return null;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
        return {
          id: p.id, handle: p.handle, title: p.title, url: p.url || '/products/' + p.handle, image: img,
          sku: (p.variants && p.variants[0] && p.variants[0].sku) || ''
        };
      })
      .catch(function () { return null; });
  }

  // Al abrir un enlace: se leen los azulejos y se muestran ANTES de guardar nada.
  function loadImportPreview() {
    if (!importData || importState) return;
    importState = 'loading';
    track('ex_shared_link_opened', { items: importData.i.length });
    var root = (cfg.root || '/').replace(/\/?$/, '/');
    var rows = typeof fetch === 'function' ? importData.i : [];
    runPool(rows.map(function (row) {
      return function () { return fetchSharedProduct(root, row); };
    }), 5).then(function (found) {
      if (!importData) return; // ya se guardó mientras cargaba
      var seen = newMap();
      importMissing = found.filter(function (it) { return !it; }).length;
      importItems = found.filter(function (it) {
        if (!it || seen[it.handle]) return false; // sin repetidos
        seen[it.handle] = 1;
        return true;
      });
      importState = importItems.length ? 'ready' : 'empty';
      renderPage();
    });
  }

  function handleKey(items) {
    return items.map(handleOf).filter(Boolean).sort().join('|');
  }

  // Variante k del nombre: 0 = el mismo · 1 = "Nombre (shared)" · 2 = "Nombre (shared 2)"…
  // (el nombre se acorta lo necesario para que siempre quepa en 60 letras)
  var NAME_TRIES = 100;
  function nameVariant(name, k) {
    if (!k) return name;
    var suffix = k === 1 ? ' (shared)' : ' (shared ' + k + ')';
    return cleanName(name.slice(0, 60 - suffix.length)) + suffix;
  }

  // ¿El cliente ya tiene este proyecto? Sí, si tiene los MISMOS azulejos con ese nombre o con el
  // que se le puso al guardarlo antes ("(shared)", "(shared 2)"…): así abrir el mismo enlace dos
  // veces no crea copias.
  function alreadyHave() {
    if (!importData || !importItems) return false;
    var key = handleKey(importItems);
    for (var k = 0; k < NAME_TRIES; k++) {
      var proj = findProject(nameVariant(importData.n, k));
      if (proj && proj.items.length && handleKey(proj.items) === key) return true;
    }
    return false;
  }

  // Nombre libre para guardar el proyecto recibido. Si el cliente ya tiene uno con ese nombre
  // (y no es lo mismo) el nuevo se guarda aparte: nunca se mezclan los azulejos de dos personas.
  function uniqueName(name) {
    for (var k = 0; k < NAME_TRIES; k++) {
      var cand = nameVariant(name, k);
      var cur = findProject(cand);
      if (!cur || !cur.items.length) return cand;
    }
    return nameVariant(name, now()); // casi imposible (100 copias): igual no se mezcla con nada
  }

  function doImport() {
    if (!importData || importState !== 'ready' || !importItems.length) return;
    var base = importData.n;
    var name = uniqueName(base);
    var items = importItems;
    var proj = addItems(name, items);
    importData = null;
    importItems = null;
    importState = '';
    importBad = false;
    // Limpia la URL para que no se vuelva a importar al recargar
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('project');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (e) { /* nada */ }
    renderPage();
    if (proj) {
      track('ex_project_imported', { items: items.length, renamed: name !== base });
      // El botón desapareció al guardar: el foco pasa al proyecto nuevo (teclado y lectores de pantalla)
      var root = pageRoot();
      var card = root && root.querySelector('[data-ex-project="' + proj.id + '"]');
      if (card) { card.setAttribute('tabindex', '-1'); card.focus({ preventScroll: true }); }
    }
    toast(proj ? (name !== base ? 'Saved as "' + proj.name + '"' : 'Project "' + proj.name + '" saved') : 'Could not save that project');
  }

  /* ---------- Dibujar la página ---------- */
  // Un azulejo. Con proyecto lleva su ✕ chica; sin proyecto (vista previa de un enlace) es solo lectura.
  function tileHtml(it, proj) {
    return '<article class="ex-tile">' +
      '<a class="ex-tile__img" href="' + esc(it.url) + '">' +
        (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy" width="300" height="300">' : '') +
      '</a>' +
      '<div class="ex-tile__info">' +
        '<a class="ex-tile__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
        (it.sku ? '<span class="ex-tile__qty">SKU: ' + esc(it.sku) + '</span>' : '') +
        (isBuyItem(it) ? '<span class="ex-tile__qty">Available to buy online</span>' : '') +
      '</div>' +
      (proj ? '<button type="button" class="ex-x ex-x--tile" data-ex-remove="' + esc(itemKey(it)) + '" aria-label="Remove ' + esc(it.title) + ' from ' + esc(proj.name) + '" title="Remove">' + X_ICON + '</button>' : '') +
    '</article>';
  }

  // EXQUISITE: tarjeta de proyecto con POCOS botones — Call to Order, Email
  // Quote Request y Order Samples, más dos íconos en la esquina: compartir y una ✕ roja
  // para borrar. Cada azulejo lleva una ✕ chica discreta. Todo lo que se quita tiene "Undo".
  function projectCardHtml(proj) {
    var n = proj.items.length;
    return '<section class="ex-folder" data-ex-project="' + esc(proj.id) + '">' +
      '<div class="ex-folder__top">' +
        '<h2 class="ex-folder__name">' + esc(proj.name) + '<span class="ex-folder__count">(' + n + ' item' + (n === 1 ? '' : 's') + ')</span></h2>' +
        '<div class="ex-folder__actions">' +
          (cfg.phone ? '<a class="ex-btn ex-btn--call" href="' + esc(telHref(cfg.phone)) + '">Call to Order</a>' : '') +
          (cfg.email ? '<a class="ex-btn" data-ex-email href="' + esc(mailHref(proj)) + '">Email Quote Request</a>' : '') +
          // Si se está agregando justo ahora y la página se vuelve a dibujar, el botón sigue "ocupado"
          '<button type="button" class="ex-btn ex-btn--dark" data-ex-order-samples' + (ordering[proj.id] ? ' disabled' : '') + '>' +
            (ordering[proj.id] ? 'Adding samples…' : SAMPLES_LABEL) + '</button>' +
        '</div>' +
        // Van al final en el HTML (así el teclado llega primero a los botones, luego a "compartir"
        // y al final a "borrar"); el CSS las coloca en la esquina de la tarjeta.
        '<button type="button" class="ex-x ex-x--share" data-ex-share aria-label="Share project ' + esc(proj.name) + '" title="Share project">' + SHARE_ICON + '</button>' +
        '<button type="button" class="ex-x ex-x--project" data-ex-delete aria-label="Delete project ' + esc(proj.name) + '" title="Delete project">' + X_ICON + '</button>' +
      '</div>' +
      '<div class="ex-folder__grid">' +
        proj.items.map(function (it) { return tileHtml(it, proj); }).join('') +
      '</div>' +
    '</section>';
  }

  // Lo que se ve arriba cuando alguien abre un enlace compartido
  function importHtml() {
    if (!importData) {
      return importBad
        ? '<div class="ex-import ex-import--bad" role="status"><span>That shared link could not be opened. Ask the sender to share it again.</span></div>'
        : '';
    }
    var name = esc(importData.n);
    if (importState === 'ready') {
      var n = importItems.length;
      return '<section class="ex-folder ex-folder--shared" data-ex-shared>' +
        '<p class="ex-folder__eyebrow">Shared with you</p>' +
        '<div class="ex-folder__top">' +
          '<h2 class="ex-folder__name">' + name + '<span class="ex-folder__count">(' + n + ' item' + (n === 1 ? '' : 's') + ')</span></h2>' +
          '<div class="ex-folder__actions">' +
            (alreadyHave()
              ? '<span class="ex-shared__note">Already in My Projects ✓</span>'
              : '<button type="button" class="ex-btn ex-btn--dark" data-ex-import>Save to My Projects</button>') +
          '</div>' +
        '</div>' +
        (importMissing ? '<p class="ex-shared__note">' + importMissing + ' item' + (importMissing === 1 ? ' is' : 's are') + ' no longer available.</p>' : '') +
        (importTotal > IMPORT_MAX ? '<p class="ex-shared__note">This link has ' + importTotal + ' items. Showing the first ' + IMPORT_MAX + '.</p>' : '') +
        '<div class="ex-folder__grid">' + importItems.map(function (it) { return tileHtml(it, null); }).join('') + '</div>' +
      '</section>';
    }
    if (importState === 'empty') {
      return '<div class="ex-import ex-import--bad" role="status"><span>We could not load the shared project <strong>' + name + '</strong>. Ask the sender to share it again.</span></div>';
    }
    return '<div class="ex-import" role="status"><span>Opening the shared project <strong>' + name + '</strong>…</span></div>';
  }

  // Dibujar la página reemplaza todo el HTML de la lista. Si el teclado estaba en un botón de una
  // tarjeta (o en la tarjeta misma), el foco vuelve al mismo lugar de la misma tarjeta: si no, se
  // iría al inicio de la página cada vez que un dato nuevo (SKU, tipo de producto) termina de llegar.
  function focusSpot(list) {
    var a = document.activeElement;
    if (!a || a === list || !list.contains(a)) return null;
    var card = a.closest('[data-ex-project], [data-ex-shared]');
    if (!card) return null;
    return {
      id: card.hasAttribute('data-ex-project') ? card.getAttribute('data-ex-project') : null, // null = vista previa
      i: a === card ? -1 : Array.prototype.indexOf.call(card.querySelectorAll('a, button'), a)
    };
  }
  function restoreFocus(list, spot) {
    if (!spot) return;
    var cards = list.querySelectorAll(spot.id === null ? '[data-ex-shared]' : '[data-ex-project]');
    var card = null;
    for (var k = 0; k < cards.length; k++) {
      if (spot.id === null || cards[k].getAttribute('data-ex-project') === spot.id) { card = cards[k]; break; }
    }
    if (!card) return;
    var el = spot.i < 0 ? card : card.querySelectorAll('a, button')[spot.i];
    if (!el) return;
    if (el === card) card.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: true });
  }

  function renderPage() {
    var root = pageRoot();
    if (!root) return;
    var list = root.querySelector('[data-ex-projects-list]');
    if (!list) return;

    var spot = focusSpot(list);
    var html = importHtml();

    var projects = state.projects.filter(function (p) { return p.items.length; })
      .sort(function (a, b) { return (b.updatedAt || 0) - (a.updatedAt || 0); });

    if (!projects.length) {
      // Con la vista previa de un enlace a la vista (o cargando) no se muestra "no has guardado
      // nada": confunde. Si el enlace falló, sí: el cliente ve cómo empezar.
      if (importState !== 'ready' && importState !== 'loading') {
        html += '<div class="ex-projects__empty"><p>You haven\'t saved any tiles yet.</p>' +
          '<p style="font-weight:400;color:#706861;">Tap the ♡ on any tile to start a project.</p>' +
          '<a class="ex-btn ex-btn--dark" href="' + esc(cfg.catalogUrl || '/collections/all') + '">Browse Catalog</a></div>';
      }
      list.innerHTML = html;
      restoreFocus(list, spot);
      return;
    }

    list.innerHTML = html + projects.map(projectCardHtml).join('');
    restoreFocus(list, spot);
    fillMissingSkus();
    fillMissingInfo();
  }

  /* Productos guardados ANTES de tener SKU: lo busca una sola vez en la
     tienda (/products/handle.js), lo guarda y vuelve a dibujar la página. */
  var skuTried = Object.create(null); // sin prototipo: un handle raro no choca con propiedades internas
  function fillMissingSkus() {
    if (typeof fetch !== 'function') return;
    var root = (cfg.root || '/').replace(/\/?$/, '/');
    var pending = [];
    state.projects.forEach(function (proj) {
      proj.items.forEach(function (it) {
        var h = it.handle || handleFromUrl(it.url);
        if (it.sku || !h || skuTried[h]) return;
        skuTried[h] = 1;
        pending.push(h);
      });
    });
    if (!pending.length) return;
    Promise.all(pending.slice(0, 60).map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return { h: h, sku: (p && p.variants && p.variants[0] && p.variants[0].sku) || '' }; })
        .catch(function () { return { h: h, sku: '' }; });
    })).then(function (rows) {
      var changed = false;
      rows.forEach(function (row) {
        if (!row.sku) return;
        state.projects.forEach(function (proj) {
          proj.items.forEach(function (it) {
            if (!it.sku && (it.handle || handleFromUrl(it.url)) === row.h) { it.sku = row.sku; changed = true; }
          });
        });
      });
      if (changed) save(); // save() ya vuelve a dibujar la página
    });
  }

  /* ==========================================================
     "ORDER ALL SAMPLES" — pide de una vez la muestra de cada
     azulejo del proyecto.
     La muestra de cada azulejo es el producto enlazado en el
     metafield custom.sample_product. Ese dato no viaja en el
     proyecto guardado, así que se lee de la página del producto
     (su botón [data-ex-sample]) y se guarda en memoria para no
     pedirla dos veces. Todo se agrega al carrito en UNA sola
     petición. Si algún azulejo no tiene muestra o está agotada,
     se avisa y se agrega el resto.
     ========================================================== */
  // Mapas por handle / id de proyecto: sin prototipo, para que un nombre raro
  // (ej. un proyecto llamado "constructor") jamás choque con propiedades internas.
  function newMap() { return Object.create(null); }

  var SAMPLE_TTL = 6 * 60 * 60 * 1000; // la muestra enlazada guardada se vuelve a verificar cada 6 h
  var TRIED_TTL = 60 * 1000;           // reintento de lo que no se pudo averiguar: máximo 1 vez por minuto

  function handleOf(it) { return it.handle || handleFromUrl(it.url); }
  function freshSample(it) { return typeof it.sample === 'string' && (now() - (it.sampleAt || 0)) < SAMPLE_TTL; }

  // Corre una lista de tareas (funciones que devuelven Promise) con un
  // máximo de 5 a la vez, para no saturar la tienda si hay muchos productos.
  function runPool(tasks, limit) {
    var results = new Array(tasks.length);
    var next = 0;
    function worker() {
      if (next >= tasks.length) return Promise.resolve();
      var i = next++;
      return tasks[i]().then(function (r) { results[i] = r; }).then(worker);
    }
    var workers = [];
    for (var w = 0; w < Math.min(limit || 5, tasks.length); w++) workers.push(worker());
    return Promise.all(workers).then(function () { return results; });
  }

  // Lee la página del producto UNA vez (aunque la pidan dos cosas a la vez) y saca:
  //  - sample: variante de su muestra (botón [data-ex-sample])
  //  - mode:   tipo del producto (viene en el JSON del botón de guardar)
  // ok=false si no se pudo leer la página (sin red, 404...): no se guarda y se reintenta.
  var pageInfoCache = newMap(); // handle -> Promise<{ ok, sample, mode }>
  function pageInfoFor(item) {
    var h = handleOf(item);
    if (!h) return Promise.resolve({ ok: false, sample: '', mode: '' });
    if (pageInfoCache[h]) return pageInfoCache[h];
    var root = (cfg.root || '/').replace(/\/?$/, '/');
    var pr = fetch(root + 'products/' + encodeURIComponent(h), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var info = { ok: !!html, sample: '', mode: '' };
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sb = doc.querySelector('.ex-pdp-actions [data-ex-sample][data-variant-id]');
          if (sb) info.sample = String(sb.getAttribute('data-variant-id') || '').replace(/[^0-9]/g, '');
          var save = doc.querySelector('.ex-pdp-actions [data-ex-save][data-ex-product]');
          if (save) {
            try {
              var m = JSON.parse(save.getAttribute('data-ex-product')).mode;
              if (isMode(m)) info.mode = m;
            } catch (e) { /* sin tipo */ }
          }
        }
        return info;
      })
      .catch(function () { return { ok: false, sample: '', mode: '' }; })
      .then(function (info) {
        if (!info.ok) delete pageInfoCache[h]; // fallo: que se pueda volver a intentar
        return info;
      });
    pageInfoCache[h] = pr;
    return pr;
  }

  // Qué productos guardados todavía no tienen su "tipo" o su muestra enlazada
  // (proyectos guardados antes de esta mejora): se completan solos, una vez.
  function triedGet() {
    var out = newMap();
    try {
      var o = JSON.parse(window.sessionStorage.getItem('ex_info_tried') || '{}') || {};
      Object.keys(o).forEach(function (k) { out[k] = o[k]; });
    } catch (e) { /* sin sessionStorage */ }
    return out;
  }
  function triedSet(map) {
    try { window.sessionStorage.setItem('ex_info_tried', JSON.stringify(map)); } catch (e) { /* sin sessionStorage */ }
  }
  var infoTried = triedGet();

  function needsInfo(it) { return !it.mode || typeof it.sample !== 'string'; }

  function fillMissingInfo() {
    var t = now();
    var pending = [];
    var queued = newMap();
    state.projects.forEach(function (proj) {
      proj.items.forEach(function (it) {
        var h = handleOf(it);
        if (!h || !needsInfo(it) || queued[h] || pending.length >= 40) return;
        if (infoTried[h] && t - infoTried[h] < TRIED_TTL) return;
        queued[h] = 1;
        infoTried[h] = t;
        pending.push(it);
      });
    });
    if (!pending.length) return;
    triedSet(infoTried);
    runPool(pending.map(function (it) {
      return function () {
        return pageInfoFor(it).then(function (info) { return { h: handleOf(it), info: info }; });
      };
    }), 5).then(function (rows) {
      var changed = false;
      rows.forEach(function (row) {
        if (!row || !row.info.ok) return;
        state.projects.forEach(function (proj) {
          proj.items.forEach(function (it) {
            if (handleOf(it) !== row.h) return;
            if (!it.mode && row.info.mode) { it.mode = row.info.mode; changed = true; }
            if (typeof it.sample !== 'string') { it.sample = row.info.sample; it.sampleAt = now(); changed = true; }
          });
        });
      });
      if (changed) save(); // save() ya vuelve a dibujar la página
    });
  }

  // Variantes que ya están en el carrito (para no duplicar muestras)
  function variantsInCart() {
    var root = (cfg.root || '/').replace(/\/?$/, '/');
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = newMap();
        (cart.items || []).forEach(function (l) { inCart[String(l.variant_id)] = 1; });
        return inCart;
      })
      .catch(function () { return newMap(); });
  }

  var ordering = newMap(); // proyecto -> true mientras se está agregando (evita doble clic)

  // Variante de la muestra de un producto: la guardada si es reciente; si no, se lee de su página.
  function sampleFor(it) {
    if (freshSample(it)) return Promise.resolve({ id: it.sample, failed: false });
    return pageInfoFor(it).then(function (info) {
      if (info.ok) {
        it.sample = info.sample;
        it.sampleAt = now();
        if (!it.mode && info.mode) it.mode = info.mode;
        return { id: info.sample, failed: false, learned: true };
      }
      // No se pudo leer la página: se usa lo último que se sabía (aunque sea viejo), si hay algo
      if (typeof it.sample === 'string') return { id: it.sample, failed: false };
      return { id: '', failed: true };
    });
  }

  function postSampleLines(root, lines) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines, sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || 'Could not add the samples.');
          err.fromShopify = true;
          throw err;
        }
        return data;
      });
    });
  }

  // Intenta todas juntas. Si Shopify rechaza el lote (ej. una muestra agotada),
  // las prueba una por una para no perder las demás.
  function addSampleLines(root, lines) {
    return postSampleLines(root, lines)
      .then(function (data) { return { data: data, added: lines.length, failed: 0 }; })
      .catch(function (err) {
        if (lines.length < 2 || !err.fromShopify) throw err;
        var added = 0;
        var failed = 0;
        var last = null;
        return lines.reduce(function (chain, line) {
          return chain.then(function () {
            return postSampleLines(root, [line])
              .then(function (d) { added++; last = d; })
              .catch(function () { failed++; });
          });
        }, Promise.resolve()).then(function () {
          if (!added) throw err;
          return { data: last, added: added, failed: failed };
        });
      });
  }

  function orderAllSamples(proj, btn) {
    if (ordering[proj.id]) return;
    ordering[proj.id] = true;
    btn.disabled = true;
    btn.textContent = 'Adding samples…';
    var root = (cfg.root || '/').replace(/\/?$/, '/');

    // La página se puede volver a dibujar mientras se agrega (ej. al completar
    // datos de otros productos): el botón puede ser otro, así que se busca el actual.
    function currentBtn() {
      var page = pageRoot();
      var folders = page ? page.querySelectorAll('[data-ex-project]') : [];
      for (var i = 0; i < folders.length; i++) {
        if (folders[i].getAttribute('data-ex-project') === proj.id) {
          return folders[i].querySelector('[data-ex-order-samples]') || btn;
        }
      }
      return btn;
    }

    function done(text) {
      ordering[proj.id] = false;
      var b = currentBtn();
      b.textContent = text || SAMPLES_LABEL;
      b.disabled = false;
      if (text) setTimeout(function () { currentBtn().textContent = SAMPLES_LABEL; }, 2500);
    }

    Promise.all([
      runPool(proj.items.map(function (it) { return function () { return sampleFor(it); }; }), 5),
      variantsInCart()
    ]).then(function (res) {
      var found = res[0];
      var inCart = res[1];
      // Lo aprendido de las páginas se guarda para la próxima vez (sin volver a dibujar la página)
      if (found.some(function (f) { return f && f.learned; })) store.set(KEY, JSON.stringify(state));
      var seen = newMap();
      var lines = [];
      var withSample = 0;
      var already = 0;
      var unchecked = 0;
      found.forEach(function (f) {
        if (f.failed) { unchecked++; return; }
        if (!f.id || seen[f.id]) return;
        seen[f.id] = 1;
        withSample++;
        if (inCart[f.id]) { already++; return; } // ya está en el carrito: no se duplica
        lines.push({ id: parseInt(f.id, 10), quantity: 1 });
      });
      var skipped = proj.items.length - withSample - unchecked;
      if (!lines.length) {
        toast(withSample
          ? 'These samples are already in your cart.'
          : (unchecked ? 'We could not check the samples right now. Please try again.'
                       : 'None of these tiles has a sample available yet. Email us and we will help.'),
          withSample ? root + 'cart' : '', 'View Cart');
        done(withSample ? 'In cart ✓' : '');
        return;
      }
      return addSampleLines(root, lines).then(function (r) {
        // Burbuja del carrito del header + aviso al resto del tema
        try {
          var html = r.data && r.data.sections && r.data.sections['cart-icon-bubble'];
          var bubble = document.getElementById('cart-icon-bubble');
          if (html && bubble) {
            var d = new DOMParser().parseFromString(html, 'text/html');
            var inner = d.querySelector('.shopify-section');
            bubble.innerHTML = inner ? inner.innerHTML : d.body.innerHTML;
          }
        } catch (e) { /* silencioso */ }
        document.dispatchEvent(new CustomEvent('ex:cart-updated', { detail: r.data }));
        var notes = [];
        if (already > 0) notes.push(already + ' already in your cart');
        if (skipped > 0) notes.push(skipped + ' without a sample');
        if (unchecked > 0) notes.push(unchecked + ' not checked');
        if (r.failed > 0) notes.push(r.failed + ' unavailable');
        toast(r.added + ' sample' + (r.added === 1 ? '' : 's') + ' added to your cart' +
          (notes.length ? ' (' + notes.join(', ') + ')' : ''), root + 'cart', 'View Cart');
        track('ex_samples_ordered', { added: r.added, items: proj.items.length });
        done('Added ✓');
      });
    }).catch(function (err) {
      toast((err && err.fromShopify && err.message) || 'Could not add the samples. Please try again.');
      done();
    });
  }

  function bindPage() {
    var root = pageRoot();
    if (!root || root.hasAttribute('data-ex-bound')) return;
    root.setAttribute('data-ex-bound', '');

    root.addEventListener('click', function (e) {
      var imp = e.target.closest('[data-ex-import]');
      if (imp) { doImport(); return; }

      var folder = e.target.closest('[data-ex-project]');
      if (!folder) return;
      var pid = folder.getAttribute('data-ex-project');
      var proj = state.projects.filter(function (p) { return p.id === pid; })[0];
      if (!proj) return;

      // ✕ chica de un azulejo: se quita y el aviso trae "Undo"
      var rm = e.target.closest('[data-ex-remove]');
      if (rm) {
        var key = rm.getAttribute('data-ex-remove');
        var gone = proj.items.filter(function (x) { return itemKey(x) === key; });
        if (!gone.length) return;
        var goneName = proj.name;
        var goneItems = JSON.parse(JSON.stringify(gone));
        var goneMeta = { createdAt: proj.createdAt, updatedAt: proj.updatedAt, index: proj.items.indexOf(gone[0]) };
        removeItemByKey(pid, key);
        var left = state.projects.filter(function (p) { return p.id === pid; })[0];
        if (left && !left.items.length) deleteProject(pid);
        track('ex_project_removed', { handles: goneItems.map(handleOf), projects: projectCount() });
        toast('Removed from ' + goneName, '', 'Undo', function () {
          restoreInto(goneName, goneItems, goneMeta);
          save();
        });
        return;
      }

      // ✕ roja de la esquina: borra el proyecto completo, con "Undo" (8 s)
      var del = e.target.closest('[data-ex-delete]');
      if (del) {
        var snapProj = JSON.parse(JSON.stringify(proj));
        deleteProject(pid);
        track('ex_project_deleted', { items: snapProj.items.length, projects: projectCount() });
        toast('Deleted ' + snapProj.name, '', 'Undo', function () {
          restoreInto(snapProj.name, snapProj.items, { createdAt: snapProj.createdAt, updatedAt: snapProj.updatedAt });
          save();
        }, UNDO_MS_PROJECT);
        return;
      }

      // Ícono de compartir: abre el menú del teléfono o copia el enlace
      var share = e.target.closest('[data-ex-share]');
      if (share) { shareProject(proj); return; }

      var orderSamples = e.target.closest('[data-ex-order-samples]');
      if (orderSamples) { orderAllSamples(proj, orderSamples); return; }

      // Correo: el enlace se abre normal (no se bloquea). El aviso le ofrece copiar el
      // mismo texto por si su celular/compu no tiene app de correo configurada.
      var mail = e.target.closest('[data-ex-email]');
      if (mail) {
        track('ex_quote_requested', { items: proj.items.length });
        toast('Opening your email app…', '', 'Not opening? Copy request', function () {
          // Se vuelve a buscar el proyecto por si cambió (otra pestaña) mientras se veía el aviso
          var cur = state.projects.filter(function (p) { return p.id === pid; })[0] || proj;
          copyText(quoteText(cur)).then(function (copied) {
            if (!copied) { toast('Could not copy. Please email us at ' + (cfg.email || 'our store') + '.'); return; }
            track('ex_quote_copied', { items: cur.items.length });
            toast('Copied. Paste it into an email, text or WhatsApp.');
          });
        }, 9000);
      }
    });
  }

  /* ==========================================================
     CORAZÓN — UNA REGLA SIMPLE (el detalle está en el encabezado del archivo)
       ♡ vacío ............................. abre la lista de proyectos
       ♥ y el cliente tiene UN proyecto ..... interruptor: se quita (con "Undo")
       ♥ y el cliente tiene 2 o más ......... abre la lista con ✓
       Botón con texto de la ficha .......... siempre abre la lista
     La regla depende de cuántos proyectos tiene el cliente, no de en cuántos está este
     azulejo: todos los corazones de una pantalla se portan igual. Nunca se borra de
     varios proyectos a ciegas, y el corazón siempre dice la verdad: lleno = está guardado.
     ========================================================== */

  // Quita el producto del proyecto donde esté (con "Undo", que lo devuelve a su lugar).
  // Si estuviera en varios, de todos: solo se llega aquí cuando el cliente tiene UN proyecto.
  function unsaveEverywhere(product) {
    var it = normItem(product);
    if (!it) return false;
    var snap = [];
    state.projects.forEach(function (proj) {
      proj.items.forEach(function (x, i) {
        if (sameItem(x, it)) {
          snap.push({
            name: proj.name,
            item: JSON.parse(JSON.stringify(x)),
            meta: { createdAt: proj.createdAt, updatedAt: proj.updatedAt, index: i }
          });
        }
      });
    });
    if (!snap.length) return false;
    // Igual que al quitarlo desde la lista: un proyecto que queda vacío se limpia solo.
    state.projects = state.projects.filter(function (proj) {
      var before = proj.items.length;
      proj.items = proj.items.filter(function (x) { return !sameItem(x, it); });
      if (proj.items.length === before) return true;
      return proj.items.length > 0; // sin tocar updatedAt: la lista no se reordena
    });
    save();
    track('ex_project_removed', { handles: [handleOf(it)], projects: projectCount() });
    toast(snap.length === 1 ? 'Removed from ' + snap[0].name : 'Removed from ' + snap.length + ' projects', '', 'Undo', function () {
      snap.forEach(function (r) { restoreInto(r.name, [r.item], r.meta); });
      save();
    });
    return true;
  }

  // Pequeño "pop" en los corazones de este producto (solo al guardar a propósito)
  function popHearts(products) {
    var keys = products.map(function (p) { return normItem(p); }).filter(Boolean);
    if (!keys.length) return;
    document.querySelectorAll('[data-ex-save]').forEach(function (btn) {
      if (btn.hasAttribute('data-ex-products')) return;
      var it = normItem(readProducts(btn)[0]);
      if (!it || !keys.some(function (k) { return sameItem(k, it); })) return;
      btn.classList.remove('ex-pop');
      void btn.offsetWidth; // reinicia la animación si se toca varias veces seguidas
      btn.classList.add('ex-pop');
      setTimeout(function () { btn.classList.remove('ex-pop'); }, 700);
    });
  }

  // Devuelve true si el toque ya quedó resuelto (no hay que abrir la lista).
  // withText = botón con texto ("Saved to Project"), no el corazón chico de la tarjeta.
  function heartTap(product, withText) {
    if (!isSaved(product)) return false;               // vacío → lista de proyectos
    if (withText || projectCount() > 1) return false;  // botón con texto, o el cliente tiene varios proyectos → lista
    return unsaveEverywhere(product);                  // un solo proyecto → interruptor (con "Undo")
  }

  /* ==========================================================
     7. EVENTOS GLOBALES
     ========================================================== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ex-save]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var products = readProducts(btn);
    // Un solo producto: ver "CORAZÓN — UNA REGLA SIMPLE" arriba
    if (products.length === 1 && heartTap(products[0], !!btn.querySelector('[data-ex-save-label]'))) return;
    openModal(products);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Otra pestaña cambió los proyectos → actualizar esta
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { load(); emit(); }
  });

  // Tarjetas nuevas (filtros, paginación, "load more") → marcar corazones
  document.addEventListener('shopify:section:load', syncHearts);
  var syncQueued = false;
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      if (syncQueued) return;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) {
          syncQueued = true;
          requestAnimationFrame(function () { syncQueued = false; syncHearts(); });
          break;
        }
      }
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }

  function init() {
    load();
    migrate();
    readImport();
    bindPage();
    if (pageRoot()) loadImportPreview(); // solo en My Projects: lee los azulejos de un enlace compartido
    emit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // API pública
  window.ExProjects = {
    open: openModal,
    close: closeModal,
    add: addItems,
    isSaved: isSaved,
    list: function () { return JSON.parse(JSON.stringify(state.projects)); },
    count: totalItems,
    refresh: function () { load(); emit(); }
  };
})();